import { action } from 'satcheljs';

/**
 * This action will get dispatched when show sender on top value is changed from message list setting
 */
const toggleFocusedInbox = action('toggleFocusedInbox');

export default toggleFocusedInbox;
